// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "section[data-v-3445f74f]{position:relative}button[data-v-3445f74f]{width:100%;height:119px;margin-top:37px}.CanvasCommunicate-date-header[data-v-3445f74f]{border-top:1px solid #ddd;margin:20px 10px 0 10px}.CanvasCommunicate-date-header p[data-v-3445f74f]{text-align:center;font-weight:700}#CanvasCommunicate-member-area[data-v-3445f74f]{line-height:30px}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
